<sd-slider
  [customConfig]="mediasConfig"
  [context]="context"
  [itemTemplate]="mediaTpl"
  [size]="sizesEnum.l"
  [items]="medias"
  [noStyle]="noStyle"
/>

<ng-template #mediaTpl let-media>
  <sd-banner
    [media]="media"
    #mediaBanner
    (mediaPlay)="onVideoPlayed()"
    (mediaEnded)="onVideoEnded()"
    [autoplayVideo]="autoplay"
    [muted]="muted"
    [loopVideo]="loop"
    [mediaTitle]="media?.mediaTitle"
    [twicPicsAutoSize]="isSlider && (medias.indexOf(media) + 1) > 1 ? true : twicPicsAutoSize"
  />
</ng-template>
